// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"impact-card_wrapper__CbF2f","title":"impact-card_title__1ZTgv","description":"impact-card_description__PXKCi"};